import styled from 'styled-components';

export const JRCModalBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: ${({ theme }) => theme.zIndex.modal};
`;

export const JRCModalContainer = styled.div`
    position: relative;
    border-radius: 8px;
    min-width: 260px;
    min-height: 260px;
    max-width: 720px;
    width: 85vw;
    max-height: 400px;
    margin: 50px;
    background-color: ${(props) => props.theme.color.white};
    display: flex;
    flex-direction: column;
    #r-left .sticky {
        min-height: 100%;
    }
    #r-main {
        display: flex;
        flex-direction: column;
    }
`;

export const JRCModalContent = styled.div`
    margin-right: 24px;
`;

export const JRCModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 8px 24px 24px 0px;
`;

export const JRCModalClose = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    margin: 16px 16px 0px 0px;
`;

export const ImgContainer = styled.div`
    min-width: 200px;
    height: 100%;
    min-height: 260px;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        max-height: 400px;
    }
`;
export const ContentContainer = styled.div`
    width: 100%;
    margin-top: 30px;
    flex-grow: 1;
    min-height: 0px;
    h2 {
        margin-bottom: 16px;
        font-weight: 500;
    }
`;
